var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpHeaderType, HttpContentType, handleResponseWithExplicitErrorMessage } from "../../common";
import { IntelligentPhotoCaptureImageDetectionConstants, PhotoCaptureServiceHeader } from '../constants';
export class PhotoCaptureIntelligentImageContentDetectionService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    photoCaptureIntelligentGetImageContentDetection(requestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = IntelligentPhotoCaptureImageDetectionConstants.IMAGE_CONTENT_DETAILS_API;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName
                }),
                body: JSON.stringify(requestPayload)
            });
            return yield this.fetchWrapper(request).then(response => handleResponseWithExplicitErrorMessage(response)
                .then(resolvedResponse => {
                return Promise.resolve(resolvedResponse);
            })
                .catch(error => {
                return Promise.reject(JSON.parse(error));
            }));
        });
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureImageContentDetectionService.js.map